(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-account"]) return;
  try {
    
function initWholesaleOrders(scope) {
  scope.querySelectorAll('[data-ud-orders]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const search = root.querySelector('[data-ud-search]');
    const filter = root.querySelector('[data-ud-filter]');
    if (!search || !filter) return;
    const cards = Array.from(root.querySelectorAll('[data-ud-order]'));
    const indexes = cards.map(card => (card.dataset.searchText + ' ' + card.textContent).toLocaleLowerCase());
    const update = () => {
      const term = search.value.trim().toLocaleLowerCase();
      let count = 0;
      cards.forEach((card, index) => {
        const matches = (filter.value === 'all' || card.dataset.state === filter.value) && indexes[index].includes(term);
        card.hidden = !matches;
        if (matches) count += 1;
      });
      root.querySelector('[data-ud-empty]').hidden = count !== 0;
    };
    search.addEventListener('input', update);
    filter.addEventListener('change', update);
    root.querySelector('[data-ud-controls]').hidden = false;
  });
}
initWholesaleOrders(document);
document.addEventListener('shopify:section:load', () => initWholesaleOrders(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ud-interface-grid"]) return;
  try {
    
if (!customElements.get('ud-interface-filter-context')) {
 customElements.define('ud-interface-filter-context', class extends HTMLElement {
  connectedCallback() {
   const view = this.dataset.view;
   if (!view) return;
   customElements.whenDefined('facet-filters-form').then(() => {
    if (!this.isConnected) return;
    const Form = customElements.get('facet-filters-form');
    if (Form.udInterfaceContext) return;
    Form.udInterfaceContext = true;
    const render = Form.renderPage;
    Form.renderPage = function(searchParams, event, updateURLHash = true) {
     const query = new URLSearchParams(searchParams);
     query.set('view', view);
     return render.call(this, query.toString(), event, updateURLHash);
    };
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ud-interface-login"]) return;
  try {
    
if (!customElements.get('ud-interface-password-toggle')) {
 customElements.define('ud-interface-password-toggle', class extends HTMLElement {
  connectedCallback() {
   const button = this.querySelector('button');
   const input = this.closest('.field').querySelector('input');
   if (!button || !input || this.ready) return;
   this.ready = true;
   button.hidden = false;
   button.addEventListener('click', () => {
    const shown = input.type === 'password';
    input.type = shown ? 'text' : 'password';
    button.setAttribute('aria-pressed', String(shown));
    button.textContent = shown ? button.dataset.hide : button.dataset.show;
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
